import { apiSlice } from "../../api/apiSlice";
import { clearCart, updateCart } from "./rewardsSlice";

export const rewardsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: ({ catId, query }) => ({
        url: `/api/rewards/products?category=${catId}&query=${query}`,
        method: "GET",
      }),
    }),
    getAllProducts: builder.query({
      query: () => ({
        url: `/api/rewards/products`,
        method: "GET",
      }),
    }),
    getAllProductsEmployee: builder.query({
      query: ({ query, category }) => ({
        url: `/api/rewards/products/get/employee?query=${query}&category=${category}`,
        method: "GET",
      }),
    }),
    createProduct: builder.mutation({
      query: (data) => ({
        url: `/api/rewards/products`,
        method: "POST",
        body: data,
      }),
    }),
    updateProduct: builder.mutation({
      query: ({ data, _id }) => ({
        url: `/api/rewards/products/${_id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    deleteProduct: builder.mutation({
      query: (productId) => ({
        url: `/api/rewards/products/${productId}`,
        method: "DELETE",
      }),
    }),
    getCategories: builder.query({
      query: () => ({
        url: `/api/rewards/categories`,
        method: "GET",
      }),
    }),
    getEmployee: builder.query({
      query: (searchQuery) => ({
        url: `/api/rewards/orders/users?query=${searchQuery}`,
        method: "GET",
      }),
    }),
    purchase: builder.mutation({
      query: (address) => ({
        url: `/api/rewards/orders`,
        method: "POST",
        body: { ...address },
      }),
      invalidatesTags: ["Points"],
    }),
    createCategory: builder.mutation({
      query: (data) => ({
        url: `/api/rewards/categories`,
        method: "POST",
        body: data,
      }),
    }),
    updateCategory: builder.mutation({
      query: ({ data, _id }) => ({
        url: `/api/rewards/categories/${_id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    deleteCategory: builder.mutation({
      query: (categoryId) => ({
        url: `/api/rewards/categories/${categoryId}`,
        method: "DELETE",
      }),
    }),
    getRedeemStatuses: builder.query({
      query: ({ status, sortBy, sortType }) => ({
        url: `/api/rewards/orders?status=${status}&sortBy=${sortBy || ""}&sortType=${
          sortType || ""
        }`,
        method: "GET",
      }),
    }),
    getEmployeeRedeemStatuses: builder.query({
      query: ({ userId, status, sortBy, sortType, page = 1, limit = 10 }) => {
        const params = new URLSearchParams();
        if (status) params.set("status", status);
        if (sortBy) params.set("sortBy", sortBy);
        if (sortType) params.set("sortType", sortType);
        if (page) params.set("page", page);
        if (limit) params.set("limit", limit);
        return {
          url: `/api/rewards/orders/employee/${userId}?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    updateRedeemStatus: builder.mutation({
      query: (data) => ({
        url: `/api/rewards/orders/status`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Points"],
    }),
    getRedeemStatus: builder.query({
      query: ({ sortBy, sortType }) => ({
        url: `/api/rewards/orders/my?sortBy=${sortBy || ""}&sortType=${
          sortType || ""
        }`,
        method: "GET",
      }),
    }),
    addCart: builder.mutation({
      query: ({ productId, newQuantity }) => ({
        url: `/api/rewards/cart/item/${productId}`,
        method: "POST",
        body: { ...newQuantity },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled, q }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(updateCart(data.data));
          // Set redux login state.
        } catch (error) {
          // console.error("error", error);
        }
      },
    }),
    clearCartProduct: builder.mutation({
      query: () => ({
        url: `/api/rewards/cart/clear`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled, q }) {
        try {
          dispatch(clearCart());
        } catch (error) {
          console.error("error", error);
        }
      },
    }),
    removeCartProduct: builder.mutation({
      query: (productId) => ({
        url: `/api/rewards/cart/item/${productId}`,
        method: "DELETE",
      }),

      async onQueryStarted(arg, { dispatch, queryFulfilled, q }) {
        try {
          const { data } = await queryFulfilled;

          dispatch(updateCart(data.data));
        } catch (error) {
          console.error("error", error);
        }
      },
    }),
    getUserCart: builder.query({
      query: () => ({
        url: `/api/rewards/cart`,
        method: "GET",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled, q }) {
        try {
          const { data } = await queryFulfilled;

          dispatch(updateCart(data.data));
        } catch (error) {
          console.error("error", error);
        }
      },
    }),
  }),
});

export const {
  useRemoveCartProductMutation,
  useGetProductsQuery,
  useGetAllProductsQuery,
  useGetCategoriesQuery,
  useGetRedeemStatusesQuery,
  useGetEmployeeRedeemStatusesQuery,
  useGetAllProductsEmployeeQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useUpdateCategoryMutation,
  useCreateCategoryMutation,
  useDeleteProductMutation,
  useDeleteCategoryMutation,
  useUpdateRedeemStatusMutation,
  useGetRedeemStatusQuery,
  useAddCartMutation,
  useGetUserCartQuery,
  usePurchaseMutation,
  useGetEmployeeQuery,
  useClearCartProductMutation,
} = rewardsApiSlice;
